var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3938_45490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0ZM9.28027 12.5996V21.7197H12.1602V12.5996H9.28027ZM13.5996 12.5996V21.7197H16.4795V16.9199C16.4795 15.9696 16.9597 14.9806 18.1211 14.9805H18.1602C19.3599 14.9999 19.8398 15.96 19.8398 16.9199V21.7197H22.7197V16.5645C22.7196 13.9103 21.1741 12.5996 19.2686 12.5996C17.4062 12.5996 16.4795 13.8291 16.4795 13.8291V12.5996H13.5996ZM10.7197 8.75977C9.85589 8.75979 9.28044 9.27347 9.28027 9.94531C9.28027 10.6173 9.85576 11.1601 10.7197 11.1602C11.6221 11.1602 12.1602 10.6173 12.1602 9.94531C12.1264 9.27345 11.5836 8.75977 10.7197 8.75977Z",
    fill: "#0B193E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3938_45490"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.cdab0eaf3b5d6b09919b8e82362e763f.svg";
export { ForwardRef as ReactComponent };